interface TopicsResult {
    category: string | null;
    id: string | null;
    subscriptionId: string | null;
    heading: string | null;
    subheading: string | null;
    disclaimer: string | null;
    backgroundImage: string | null;
    buttonText: string | null;
    success: boolean;
}

async function initialisePersonalisedTopicForms() {
    const dynamicPersonalisedBlocks = document.querySelectorAll('.dynamic-personalised-form-block');

    if (dynamicPersonalisedBlocks.length !== 0) {
        dynamicPersonalisedBlocks.forEach(async (block) => await processDynamicPersonalisedFormBlock(block, fetchDynamicBlockData));
    }

    const filteredPersonalisedBlocks = document.querySelectorAll('.filtered-personalised-form-block');

    if (filteredPersonalisedBlocks.length !== 0) {
        filteredPersonalisedBlocks.forEach(async (block) => await processDynamicPersonalisedFormBlock(block, fetchFilteredBlockData));
    }
}

async function processDynamicPersonalisedFormBlock(FormBlock: Element, blockDataGetter: Function) {
    //find the ve-dynamicform element
    const veDataElement = FormBlock.querySelector('ve-dynamicform');
    if (!veDataElement) return;

    const blockId = veDataElement.getAttribute('data-blockid');

    if (!blockId) return;

    if (FormBlock.classList.contains("restricted-to-recommendation")) {
        let isRecommendation = false;
        const urlParams = new URLSearchParams(window.location.search);
        for (const [key, _] of urlParams) {
            if (key.match(/^it(e|o|q|x\[(\w+)])$/)) {
                isRecommendation = true;
                break;
            }
        }
        if (!isRecommendation) {
            FormBlock.classList.add("d-none");
            return;
        }
    }
    
    const blockTopicData : TopicsResult = await blockDataGetter(blockId);

    if(!blockTopicData || blockTopicData.success === false) {
        FormBlock.classList.add("d-none");
        return;
    }

    //log it to console
    console.log("%c **** BLOCK TOPIC DATA ****", "background-color: darkgreen; font-weight: bold; color: white; font-size: 16px;");
    console.log(blockTopicData);

    //set the heading
    const heading = FormBlock.querySelector('.personalised-heading');
    if (heading && blockTopicData.heading != null) {
            heading.innerHTML = blockTopicData.heading;
    }

    //set the subheading
    const subHeading = FormBlock.querySelector('.personalised-sub-heading');
    if (subHeading && blockTopicData.subheading != null) {
        subHeading.innerHTML = blockTopicData.subheading;
    }

    //set the disclaimer
    const disclaimer = FormBlock.querySelector('.personalised-disclaimer');
    if (disclaimer && blockTopicData.disclaimer != null) {
        disclaimer.innerHTML = blockTopicData.disclaimer;
    }

    //set the subscriptions
    const subscriptions = FormBlock.querySelector('input.SubscriptionId');
    if (subscriptions && blockTopicData.subscriptionId != null) {
        subscriptions.setAttribute('value', blockTopicData.subscriptionId);
    }

    //set the image
    const backgroundImageContainer = FormBlock.querySelector('.personalized-background');
    if (backgroundImageContainer && blockTopicData.backgroundImage != null) {
        backgroundImageContainer.setAttribute('style', `background-image: url('${blockTopicData.backgroundImage}')`);
    }

    //set the submit button text
    const submitButton = FormBlock.querySelector('.FormSubmitButton');
    if (submitButton && blockTopicData.buttonText != null) {
        submitButton.innerHTML = blockTopicData.buttonText;
    }

    FormBlock.classList.remove("d-none");

    document.dispatchEvent(new CustomEvent("reEvaluateSidebar"));
}

async function fetchDynamicBlockData(blockId: string) {
    try {
        const pageId = document.querySelector("[property='idio:content_id']")?.getAttribute("content") ?? "0";
        const visitedPages = JSON.parse(localStorage.getItem("ve-visited-pages") ?? "[]");
        const visitedPagesQuery = visitedPages.map((item: any) => `visitedPages=${encodeURIComponent(item)}`).join('&');
        let additionalParams = `&${visitedPagesQuery}`;

        //fetch the dynamic content data
        const fetchResult = await fetch(`/main/dynamicsubscriptionformblock/gettopics/?blockId=${blockId}&pageId=${pageId}&currentPageUrl=${document.location.href}${additionalParams}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        })
        const TopicData: TopicsResult = await fetchResult.json();
        return TopicData;
    }
    catch (e) {
        console.log("Failed fetching dynamic form data.")
        console.error(e);
    }

    return null;
}

async function fetchFilteredBlockData(blockId: string) {
    try {
        const vuid = decodeURI((getCookie("vuid") ?? "")).split("|")[0];
        const fetchResult = await fetch(`/main/filteredsubscriptionformblock/getsubscription/?blockId=${blockId}&vuid=${vuid}&currentPageUrl=${document.location.href}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        })
        const TopicData: TopicsResult = await fetchResult.json();
        return TopicData;
    }
    catch (e) {
        console.log("Failed fetching filtered form data.")
        console.error(e);
    }

    return null;
}

function getCookie(name: string) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop()?.split(';').shift();
}

window.addEventListener('DOMContentLoaded', initialisePersonalisedTopicForms);
